<template>
  <v-container
    class="auction"
    fluid
  >
    <v-row class="align-center">
      <v-col class="fill-height auction-col">
        <Heading
          class="auction__subtitle"
          level="2"
          font-color="#EE396C"
          line-height="50px"
          font-size="36px"
        >
          {{ artist.subtitle }}
        </Heading>
        <Heading
          class="auction__title"
          level="1"
        >
          {{ artist.title }}
        </Heading>
        <p class="auction__description">
          {{ artist.description }}
          <span>Leia mais</span>
        </p>
        <v-row>
          <v-col
            v-for="index in 6"
            :key="index"
            class="col-4"
          >
            <v-img
              :src="formatImageURL(index)"
              @click="gotoLote(1)"
            ></v-img>
          </v-col>
        </v-row>
        <Button
          color="#ffffff"
          background-color="#EE396C"
          text=""
          height="52px"
          font-size="17px"
          padding="15px 28px"
          class="auction__btn"
        >
          Quero ser avisado quando começar
        </Button>
      </v-col>
      <v-col
        class="fill-height col--aligned"
        align-self="center"
      >
        <v-img
          max-width="690px"
          max-height="728px"
          class="auction__img"
          :src="artist.mainImage"
        ></v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Button from '@/components/Button/Button.vue';
import Heading from '@/components/Heading/Heading.vue';

export default {
  name: 'NextAuction',
  components: {
    Button,
    Heading,
  },
  data() {
    return {
      artist: {
        title: 'Celina Portella',
        subtitle: 'Leilão em 27 de Março',
        description:
          'A marreta que golpeava com violência a imagem projetada na parede anunciava o que estava por vir. No minuto final do vídeo Derrube (2009), o desaparecimento da imagem e o rombo deixado em seu lugar sinalizavam o território para a onde a pesquisa artística de Celina Portella se encaminharia ao longo de toda a década seguinte. A fantasmagoria. O absurdo. O ininteligível.',
        mainImage: require('../../assets/nextauction-image.png'),
      },
    };
  },
  methods: {
    formatImageURL(index) {
      return require(`../../assets/auction-${index}.png`);
    },
    gotoLote(n) {
      this.$router.push({
        name: this.$consts.ROUTES.LEILAO_LOTE.NAME,
        params: {
          leilao: this.$route.params.leilao,
          lote: n,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/static/css/Variables.scss';
.auction {
  position: relative;
  overflow: hidden;
  padding: 40px 80px 60px 80px;
  padding-top: 40px;
  padding-bottom: 60px;

  &__img {
    @media (max-width: $lg) {
      display: none !important;
    }
    @media (max-width: $xl) {
      max-width: 500px !important;
    }
  }

  &-col {
    @media (max-width: $lg) {
      flex-basis: auto;
    }
  }

  @media (max-width: $sm) {
    padding: 20px;
  }

  > * {
    z-index: 10;
    position: relative;
  }

  &:after {
    content: '';
    z-index: 0;
    width: 975px;
    height: 1230px;
    position: absolute;
    left: 917px;
    bottom: 155px;
    background: linear-gradient(317.33deg, #292667 -64.75%, #ee396c 78.06%);
    transform: rotate(-38.19deg);
  }
  &__subtitle {
    margin-top: 30px;
    @media (max-width: $md) {
      font-size: 16px !important;
      line-height: 14px !important;
    }
  }
  &__title {
    margin-bottom: 20px;
    @media (max-width: $sm) {
      margin-bottom: 0;
    }
    @media (max-width: $md) {
      font-size: 26px !important;
    }
  }
  &__description {
    width: 90%;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: -0.015em;
    color: rgba(0, 0, 0, 0.8);
    margin-bottom: 40px;
    > span {
      color: #ee396c;
    }
    @media (max-width: $sm) {
      font-size: 14px;
    }
    @media (max-width: $md) {
      line-height: 20px;
      font-size: 16px;
    }
  }

  &__btn {
    margin-top: 40px;
  }

  .col {
    &--aligned {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
